<!-- 현장 정보 -->
<template>
  <div class="mt-5">
    <vs-row v-if="!!title" class="my-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> {{ title }}</h5>
      </vs-col>
    </vs-row>
    <div class="w-full grid" style="grid-template-columns: 1fr 1fr 1fr; column-gap: 1.5rem">
      <div v-if="types.includes('field_name')" class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
        <div class="label-text mr-4">{{ typesLabel.field_name || "사업장명" }}</div>
        <p v-if="isPrint" class="print-input">{{ info.field_name }}</p>
        <ml-input v-else readonly v-model="info.field_name" placeholder="자동입력" class="w-full flex-1" />
      </div>
      <div v-if="types.includes('director_name')" class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
        <div class="label-text mr-4">{{ typesLabel.director_name || "담당 주무관" }}</div>
        <p v-if="isPrint" class="print-input">{{ info.director_name }}</p>
        <ml-input v-else readonly v-model="info.director_name" placeholder="자동입력" class="w-full flex-1" />
      </div>
      <div v-if="types.includes('date_range')" class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
        <div class="label-text mr-4">{{ typesLabel.date_range || "사업기간" }}</div>
        <p v-if="isPrint" class="print-input">{{ info.work_begin_at }} ~ {{ info.work_end_at }}</p>
        <div v-else class="flex items-center gap-3">
          <date-selector readonly v-model="info.work_begin_at" class="w-full flex-1" placeholder="자동입력" />
          <span>~</span>
          <date-selector readonly v-model="info.work_end_at" class="w-full flex-1" placeholder="자동입력" />
        </div>
      </div>
      <div v-if="types.includes('deposit_amount')" class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
        <div class="label-text mr-4">{{ typesLabel.deposit_amount || "사업금액" }}</div>
        <p v-if="isPrint" class="print-input">{{ info.deposit_amount }}</p>
        <ml-input v-else readonly v-model="info.deposit_amount" placeholder="자동입력" class="w-full flex-1" />
      </div>
      <div v-if="types.includes('address')" class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
        <div class="label-text mr-4">{{ typesLabel.address || "사업장 주소" }}</div>
        <p v-if="isPrint" class="print-input">{{ info.address }}</p>
        <ml-input v-else readonly v-model="info.address" placeholder="자동입력" class="w-full flex-1" />
      </div>
      <div v-if="types.includes('phone')" class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
        <div class="label-text mr-4">{{ typesLabel.phone || "사업장 연락처" }}</div>
        <p v-if="isPrint" class="print-input">{{ info.phone }}</p>
        <ml-input v-else readonly v-model="info.phone" placeholder="자동입력" class="w-full flex-1" />
      </div>
      <div v-if="types.includes('facility_category')" class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
        <div class="label-text mr-4">{{ typesLabel.cat1 || "구분" }}</div>
        <p v-if="isPrint" class="print-input">{{ info.cat1 }}</p>
        <ml-input v-else readonly v-model="info.cat1" placeholder="자동입력" class="w-full flex-1" />
      </div>
      <div v-if="types.includes('facility_category')" class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
        <div class="label-text mr-4">{{ typesLabel.cat2 || "종류" }}</div>
        <p v-if="isPrint" class="print-input">{{ info.cat2 }}</p>
        <ml-input v-else readonly v-model="info.cat2" placeholder="자동입력" class="w-full flex-1" />
      </div>
      <div v-if="types.includes('facility_category')" class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
        <div class="label-text mr-4">{{ typesLabel.cat3 || "세분류" }}</div>
        <p v-if="isPrint" class="print-input">{{ info.cat3 }}</p>
        <ml-input v-else readonly v-model="info.cat3" placeholder="자동입력" class="w-full flex-1" />
      </div>
      <div v-if="types.includes('manager_name')" class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
        <div class="label-text mr-4">{{ typesLabel.manager_name || "현장소장" }}</div>
        <p v-if="isPrint" class="print-input">{{ info.manager_name }}</p>
        <ml-input v-else readonly v-model="info.manager_name" placeholder="자동입력" class="w-full flex-1" />
      </div>
      <div v-if="types.includes('safety_manager_name')" class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
        <div class="label-text mr-4">{{ typesLabel.safety_manager_name || "안전관리자" }}</div>
        <p v-if="isPrint" class="print-input">{{ info.safety_manager_name }}</p>
        <ml-input v-else readonly v-model="info.safety_manager_name" placeholder="자동입력" class="w-full flex-1" />
      </div>
      <div v-if="types.includes('contract_code')" class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
        <div class="label-text mr-4">{{ typesLabel.contract_code || "계약번호(시스템)" }}</div>
        <p v-if="isPrint" class="print-input">{{ info.contract_code }}</p>
        <ml-input v-else readonly v-model="info.contract_code" placeholder="자동입력" class="w-full flex-1" />
      </div>
    </div>
  </div>
</template>

<script>
import HttpRequest from "@/util/HttpRequest";
import DateSelector from "@/components/selector/DateSelector";

export default {
  name: "FieldInfo",
  components: { DateSelector },
  props: {
    title: String,
    isPrint: Boolean,
    types: {
      type: Array,
      default: () => {
        return ["field_name", "director_name", "date_range", "deposit_amount", "address", "phone", "facility_category", "manager_name", "safety_manager_name", "contract_code"];
      },
    },
    typesLabel: {
      type: Object,
      default: () => {
        return {
          field_name: "사업장명",
          director_name: "담당 주무관",
          date_range: "사업기간",
          deposit_amount: "사업금액",
          address: "사업장 주소",
          phone: "사업장 연락처",
          cat1: "구분",
          cat2: "종류",
          cat3: "세분류",
          manager_name: "현장소장",
          safety_manager_name: "안전관리자",
          contract_code: "계약번호(시스템)",
        };
      },
    },
    fieldId: { type: Number || null, default: null },
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
      info: this.value,
    };
  },
  watch: {
    fieldId: {
      immediate: true,
      deep: true,
      async handler(value) {
        if (!!value) {
          new Promise((resolve, reject) => {
            HttpRequest.get(`/api/v1/field/${value}`)
              .then((response) => {
                const { field_name, director_name, work_begin_at, work_end_at, deposit_amount, address, phone, facility_category, manager_name, safety_manager_name, contract_code } = response;
                this.info = {
                  field_name,
                  director_name,
                  work_begin_at,
                  work_end_at,
                  deposit_amount,
                  address,
                  phone,
                  cat1: !!facility_category ? facility_category.cat1 : "",
                  cat2: !!facility_category ? facility_category.cat2 : "",
                  cat3: !!facility_category ? facility_category.cat3 : "",
                  manager_name,
                  safety_manager_name,
                  contract_code,
                };
              })
              .catch((err) => reject(err));
          });
        }
      },
    },
    value: {
      handler(value) {
        this.info = value;
      },
    },
    info: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  mounted(){
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
</style>
